import React, { useEffect, createElement } from 'react';
import { TopBar } from './components/TopBar';
import { Hero } from './components/Hero';
import { Testimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { Transformation } from './components/Transformation';
import { ProductOverview } from './components/ProductOverview';
import { BeforeAfter } from './components/BeforeAfter';
import { Bonuses } from './components/Bonuses';
import { Pricing } from './components/Pricing';
import { Upsell } from './components/Upsell';
import { MoreTestimonials } from './components/MoreTestimonials';
import { PostTestimonialsOffer } from './components/PostTestimonialsOffer';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { CostComparison } from './components/CostComparison';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchaseNotification } from './components/PurchaseNotification';
import { StickyMobileCTA } from './components/StickyMobileCTA';
declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void;
    _fbq?: unknown;
  }
}
export function App() {
  // Meta Pixel
  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (window.fbq) return;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const f: any = window;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const n: any = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    f.fbq = n;
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    try {
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const target = document.head || document.body || document.documentElement;
      if (target) target.appendChild(script);
      window.fbq?.('init', '1202545065289126');
      window.fbq?.('track', 'PageView');
    } catch (err) {
      console.warn('Meta Pixel could not be loaded:', err);
    }
  }, []);
  return <div className="min-h-screen bg-background text-white selection:bg-primary selection:text-black" data-id="element-0">
      <TopBar data-id="element-1" />
      <main data-id="element-2">
        {/* 1 — Hero */}
        <Hero data-id="element-3" />
        {/* 2 — Quick social proof */}
        <Testimonials data-id="element-4" />
        {/* 3 — Pain */}
        <PainPoints data-id="element-5" />
        {/* 4 — Transformation */}
        <Transformation data-id="element-6" />
        {/* 5 — Solution + 6 Tomos + What includes */}
        <ProductOverview data-id="element-7" />
        {/* 6 — Before/After */}
        <BeforeAfter data-id="element-8" />
        {/* 7 — Bonuses */}
        <Bonuses data-id="element-9" />
        {/* 8 — Pricing (countdown 1 + offer) */}
        <Pricing data-id="element-10" />
        {/* 9 — Upsell explanation */}
        <Upsell data-id="element-11" />
        {/* 10 — Long testimonials */}
        <MoreTestimonials data-id="element-12" />
        {/* 10.5 — Replicated offer right below testimonials */}
        <PostTestimonialsOffer data-id="element-13" />
        {/* 11 — Guarantee */}
        <Guarantee data-id="element-14" />
        {/* 12 — FAQ */}
        <FAQ data-id="element-15" />
        {/* 13 — Cost of not changing */}
        <CostComparison data-id="element-16" />
        {/* 14 — Final close + countdown 2 */}
        <FinalCTA data-id="element-17" />
      </main>
      <Footer data-id="element-18" />

      {/* Floating */}
      <PurchaseNotification data-id="element-19" />
      <StickyMobileCTA data-id="element-20" />

      {/* Meta Pixel noscript fallback */}
      <noscript data-id="element-21">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1202545065289126&ev=PageView&noscript=1" alt="" data-id="element-22" />
      </noscript>
    </div>;
}